// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxField_checkbox__1X25c"};